// @flow

import * as React from 'react';

import { Base, useDisclosure, Svg } from '@gandi/ui';
import { Action } from '@gandi/ui/deprecated';
import type {
  TranslatorProps,
  TranslatorFunctionReturn,
  HtmlTranslatorFunctionOptions,
} from '@gandi/translate';

import styles from './FAQCollapsible.scss';

type Props = {|
  translator: TranslatorProps,
|};

const FAQDetails = ({
  content,
  title,
}: {|
  title: TranslatorFunctionReturn<HtmlTranslatorFunctionOptions>,
  content: TranslatorFunctionReturn<HtmlTranslatorFunctionOptions>,
|}) => {
  const { open, triggerProps, contentProps } = useDisclosure();
  return (
    <>
      <div
        itemScope
        itemProp="mainEntity"
        itemType="https://schema.org/Question"
      >
        {/* eslint-disable-next-line react/no-danger */}
        <Action
          variant="block"
          separatorBottom
          icon={open ? 'miniChevronTop' : 'miniChevronBottom'}
          {...triggerProps}
        >
          {/* $FlowFixMe[incompatible-type] */}
          <span dangerouslySetInnerHTML={title} itemProp="name" />
        </Action>
      </div>
      <div
        {...contentProps}
        itemScope
        itemProp="acceptedAnswer"
        itemType="https://schema.org/Answer"
      >
        <Base
          padding="small"
          backgroundColor="grey-lighter"
          separatorBottom
          dangerouslySetInnerHTML={content}
          itemProp="text"
        />
      </div>
    </>
  );
};

const FAQCollapsible = (props: Props) => {
  const { __ } = props.translator;

  const couples = [
    {
      title: __('help_faq_question_1', {
        withHTML: true,
      }),
      content: __('help_faq_answer_1', {
        withHTML: true,
      }),
    },
    {
      title: __('help_faq_question_2', {
        withHTML: true,
      }),
      content: __('help_faq_answer_2', {
        withHTML: true,
      }),
    },
    {
      title: __('help_faq_question_3', {
        withHTML: true,
      }),
      content: __('help_faq_answer_3', {
        withHTML: true,
      }),
    },
    {
      title: __('help_faq_question_4', {
        withHTML: true,
      }),
      content: __('help_faq_answer_4', {
        withHTML: true,
      }),
    },
  ];

  return (
    <Base marginBottom="base">
      {couples.map(({ content, title }, index) => (
        <div key={String(title)} id={`faq-${index}`}>
          <FAQDetails content={content} title={title} />
        </div>
      ))}
      <Base align="end" paddingY="small">
        <a
          href="https://docs.gandi.net/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {__('See Documentation')}
          <Svg
            className={styles.svg}
            name="arrowRight"
            theme="green"
            title={__('Documentation')}
          />
        </a>
      </Base>
    </Base>
  );
};

export default (React.memo(FAQCollapsible): React.AbstractComponent<Props>);
